/**
 * Guilloche rosette — the ChainEvidence seal (SPA copy of the canonical
 * src/components/SealMark.tsx; kept dependency-free on purpose since the
 * SPA and the Next app have separate toolchains).
 */
export function SealMark({ size = 28, className = "" }: { size?: number; className?: string }) {
  const c = size / 2;
  const petals = 9;
  const rx = size * 0.41;
  const ry = size * 0.165;
  const angles = Array.from({ length: petals }, (_, i) => (i * 180) / petals);
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" aria-hidden="true" className={className}>
      <circle cx={c} cy={c} r={size * 0.465} stroke="currentColor" strokeWidth={size * 0.033} opacity={0.8} />
      {angles.map((a) => (
        <ellipse
          key={a}
          cx={c}
          cy={c}
          rx={rx}
          ry={ry}
          stroke="currentColor"
          strokeWidth={size * 0.026}
          opacity={0.72}
          transform={`rotate(${a} ${c} ${c})`}
        />
      ))}
    </svg>
  );
}
